<template src="./quickbookIntegration.template.html"></template>
<script>
import VeeValidate from "vee-validate";
import Vue from "vue";

Vue.use(VeeValidate);

const dummyObj = {
  Active: "6",
  Amount: "null",
  AuthenticationCount: "1",
  BookingEngineCount: "2",
  CalculatedDerivedRates: "null",
  ClientId: "5",
  ClientSyncInventory: "0",
  ClientSyncRates: "0",
  ClientSyncRestrictions: "0",
  CrsId: "2",
  CrsName: "Rentals United",
  CrsStatus: "null",
  EmailId: "null",
  InActive: "56",
  IntegrationId: 9,
  Integrators_UserId: "null",
  IsDefault: "true",
  Password:
    "eyJhbGciOiJIUzI1NiJ9.QXBwbGUjMTIz.1Qkx6SAWTHe0Ag6smjH11KyQCLB7W2S9BkriIa853lI",
  PaymentConnectionId: "null",
  PaymentGatewayCount: "6",
  PhoneNumber: "null",
  RatePlanId: "null",
  StatusId: "1",
  SyncInventory: "true",
  SyncRates: "true",
  SyncRestrictions: "true",
  UserName: "QuickBooks",
  User_ApiKey: "KKaeoWJPpVeV3gO0Dz3w2hj7X",
  derivedRateplanId: "null",
  isPercentage: "null",
  isPositive: "null",
};
export default {
  name: "quickbookIntegration",
  props: [
    "parentComponentName",
    "componentIntegrationId",
    "showQuickBookAccountPanel",
    "showQuickbookAccountDetails",
    "getIntegrationList",
    "isIntegratedStatus",
    "unitId",
    "propertyId",
    "hideQuickbookDetails",
    "showQuickbookClientDetails",
    "updateQBUserDetailList"
  ],
  data() {
    return {
      quickbookUserList: [],
      selectedQuickbookUser: {},
      ShowAllAccount: true,
      quickbookLoginDetails: {
        userName: "",
        password: "",
        showQuickbookLogin: false,
      },
    };
  },
  methods: {
    addUserInQuickbook(event) {
      let vm = this;
      vm.showQuickBookAccountPanel(event);
    },
    connectQuickbookAccount(event) {
      let vm = this;
      vm.quickbookLoginDetails.showQuickbookLogin = true;
      vm.hideQuickbookDetails();
      event.stopPropagation();
    },
    getQuickbookAccountList() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_ListOfIntegrations_RU",
        params: {
          ModuleAction: "Get_ListOfIntegrations_RU",
          PropertyId: vm.propertyId ? vm.propertyId : null,
          UnitId: vm.unitId ? vm.unitId : null,
        },
        callback: function (err, response) {
          console.log("quikbookUserList", response);
          if (response[0].length) {
            vm.quickbookUserList = response[0]; 
            // vm.selectedQuickbookUser = vm.quickbookUserList.filter(element => {
            //     if (element.IntegrationId == vm.componentIntegrationId)
            //         return element

            // })[0];
            vm.quickbookUserList.push(dummyObj);
            console.log("quickbookUserList=---", vm.quickbookUserList);
            vm.$store.commit('setQuickbookAccountList',vm.quickbookUserList)
          }
        },
      });      
    },
    quickbookAccountLogin() {
      let vm = this;
      if (
        vm.quickbookLoginDetails.userName == "" ||
        vm.quickbookLoginDetails.password == ""
      ) {
        vm.$store.dispatch("toastr", {
          type: "error",
          header: "Error!",
          message: "Please enter all details!!",
        });
      }
      if (
        vm.quickbookUserList.find((qbUser) =>vm.quickbookLoginDetails.userName.trim().toLowerCase() == qbUser.UserName.trim().toLowerCase())) {
                      vm.$store.dispatch("toastr", {
                         type: "warning",
                         header: "Warning!",
                         message: "Account already exist with same username",
                       });
        vm.quickbookLoginDetails.userName = "";
        vm.quickbookLoginDetails.password = "";
        return;
      } 
      else {

        vm.quickbookLoginDetails.showQuickbookLogin = false;
      }
    },
    closeQuickBookLoginPanel() {
      let vm = this;
      vm.quickbookLoginDetails.showQuickbookLogin = false;
    },
     inActiveBtnClick(event) {
        var vm = this;
        if (event.target.tagName != "I" && event.target.getAttribute("title") != "DropDownMenu") {
          event.stopPropagation();
        }
      },
      showQuickbookDetails(event, clientName, quickbookUser) {
        var vm = this;
        console.log("quickbookUser===",event);
        if (quickbookUser.StatusId != 1) {
          return
        }
        if (event.target.tagName != "I" && event.target.getAttribute("title") != "DropDownMenu") {
          if (vm.parentComponentName == 'integration') {
            vm.showQuickbookClientDetails(clientName);
          }
        }
      },
      GetCrsPropertyList(event, userName, quickbookUser) {
        var vm = this;
        if (quickbookUser.StatusId != 1) {
          return
        }
        if (event && (event.target.tagName == "I" || event.target.getAttribute("title") == "DropDownMenu" || vm.parentComponentName != "integration")) {
          return;
        }
        vm.updateQBUserDetailList(userName, "", "All");
      },
    // getQuickbookListData(quickbookUser){
    //     let vm=this;
    //     if (quickbookUser.StatusId == 0 && vm.ShowAllAccount) {
    //         return false
    //     } else if ((quickbookUser.StatusId == 1 && vm.ShowAllAccount) || !vm.ShowAllAccount) {
    //         return true
    //     }

    // }
  },
  watch: {},
  computed: {},
  mounted() {
    this.getQuickbookAccountList();
  },
};
</script>
